
import React, { useEffect, useState, useRef } from 'react';
import { useLoader } from '@react-three/fiber'
import { Html, OrbitControls, Text, Billboard, Line } from '@react-three/drei'
import { TextureLoader } from "three/src/loaders/TextureLoader";
//import { Selection, Select, EffectComposer, SelectiveBloom } from '@react-three/postprocessing'
//import * as THREE from 'three'
import data from './dataLatest.json'
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import { InlineLoading } from 'carbon-components-react';
import i18n from "../../i18n"

const loadingLabel = i18n.t('pageHeader.app.loadingLabel');
const NoDataAvailable = i18n.t('IncidentDetails.NoDataAvailable');

const determineStatusColor = (status, type) => {
    //determine color for servers based on status number
    if (status === 0) {
        return '#a8a8a8'; //grey
    }
    else if (status === 1) {
        return '#42BE65'; //green
    }
    else if (status === 2) {
        return '#F1C21B'; //yellow
    }
    else if (status >= 3) {
        return type === "popup" ? "#DA1E28" : '#FF2802'; //red
    }
    else return "grey";
}

const Scene3D = (props) => {
    const [SAPMonitoringData, setSAPMonitoringData] = useState([]);
    const [SAPMonitoringLoading, setSAPMonitoringLoading] = useState(true);
    //const [gridHelperxy, setgridHelperxy] = useState([30, 0]);
    //const [parentClickID, setParentClickID] = React.useState(false);
    const [childrenClickID, setChildrenClickID] = useState("");
    const [childHoverID, setChildHoverID] = useState("");
    const [selectedLens, setSelectedLens] = useState("Availability");
    const [selectedName, setSelectedName] = useState("");

    const [
        server1Front, server2Front, server3Front,
        server1Top, server2Top, server3Top,
        server1Right, server2Right, server3Right
    ] = useLoader(TextureLoader,
        [
            'images/Server1Front.png', 'images/Server2Front.png', 'images/Server3Front.png',
            'images/Server1Top.png', 'images/Server2Top.png', 'images/Server3Top.png',
            'images/Server1Right.png', 'images/Server2Right.png', 'images/Server3Right.png'
        ]);

    useEffect(() => {
        setSelectedLens(props.selectedLens);
    }, [props.selectedLens]);

    useEffect(() => {
        //visibility set as false when collapse is clicked
        if (props.IsExpandCollapse === "collapse") {
            setChildHoverID("");
            setChildrenClickID("");
            setSAPMonitoringData(SAPMonitoringData.map((data) => {
                return {
                    ...data,
                    children: data.children.map(child => {
                        return { ...child, visible: false }
                    }
                    )
                };
            }));
        }

        //visibility set as false when expand is clicked
        if (props.IsExpandCollapse === "expand") {
            setSAPMonitoringData(SAPMonitoringData.map((data) => {
                return {
                    ...data,
                    children: data.children.map(child => {
                        return { ...child, visible: true }
                    }
                    )
                };
            }));
        }
    }, [props])


    useEffect(() => {
        getSAPMonitoringData();
    }, []);

    useEffect(() => {
        if (childrenClickID && childrenClickID !== "") {
            let propertyArray = [];
            SAPMonitoringData.forEach(data => {
                data.children.forEach(child => {
                    if (childrenClickID === child.id)
                        if (child.property && child.property.length > 0) {
                            child.property.filter(item => {
                                if (item.Category === props.selectedLens) {
                                    propertyArray = item.propertyElements;
                                }
                            });
                        }
                })
            })
            props.getSelectedNodeDetails(propertyArray, selectedName);
        }
    }, [props.selectedLens])

    function handleParentClick(id, property) {
        //to toggle clicks and hide/show the boxes accordingly
        setSAPMonitoringData(SAPMonitoringData.map((data) => {
            if (data.id === id) {
                if (data && data.children && data.children.length > 0) {
                    return {
                        ...data,
                        children: data.children.map(child => {
                            child.visible === false ? props.getSelectedNodeDetails(property, data.Name) : props.getSelectedNodeDetails([], "");
                            return { ...child, visible: !child.visible }
                        })
                    };
                }
                else {
                    props.getSelectedNodeDetails([], data && data.Name ? data.Name : "");
                    return { ...data, children: [] };
                }
            }
            else return {
                ...data,
                children: data.children.map(child => {
                    return { ...child, visible: child.visible }
                }
                )
            };
        }))

        //used to assign selected View as empty so that the collapse and expand button can work when clicked again.
        props.switchExpandCollapseView("");
    }

    function getSAPMonitoringData() {
        setSAPMonitoringLoading(true);
        let formattedData = prepareSAPMonitoringData(data);
        setSAPMonitoringData(formattedData);
        setSAPMonitoringLoading(false);
        // callPostApi(Constants.GETSAPMONITORING, { 'Content-Type': 'application/json' }, {})
        //     .then(response => {
        //         console.log(response);
        //         let formattedData = prepareSAPMonitoringData(response);
        //         setSAPMonitoringData(formattedData);
        //         setSAPMonitoringLoading(false);
        //     })
        //     .catch((error) => {
        //         console.error('Error:', error);
        //         setSAPMonitoringLoading(false);
        //     });
    }

    const prepareSAPMonitoringData = (response) => {
        let buckets = response;
        let boxObj = {}; let boxArray = [];
        let childrenObj = {}; let childrenArray = [];
        let propertyObj = {}; let propertyArray = [];
        let downPosition = 25; //change this to move everything left and right
        let initialDownPosition = -9; //change this to move parent boxes

        let upperPosition = downPosition - 5; //change this to move everything left and right
        let initialUpperPosition = initialDownPosition - 8; //change this to move parent boxes
        let splitNumber = (buckets.length - 1) / 2;
        //setgridHelperxy([80, 1]);
        let visible;
        //to sort buckets as per children length
        // buckets.sort((a, b) => { if (a.SystemToHeader.results.length > b.SystemToHeader.results.length) { return -1; } else return 1; });
        for (let i = 0; i < buckets.length; i++) {
            if (i <= splitNumber) {
                downPosition = downPosition - 10;
            }
            else upperPosition = upperPosition - 10;

            childrenArray = [];
            boxObj = {
                id: i + 1,
                Name: buckets[i].Name,
                Contextid: buckets[i].Contextid ? buckets[i].Contextid : "",
                ParentContextid: buckets[i].ParentContextid ? buckets[i].ParentContextid : "",
                ObjectType: buckets[i].ObjectType ? buckets[i].ObjectType : "",
                children: [],
                position: [i <= splitNumber ? initialDownPosition : initialUpperPosition, 1.5, i <= splitNumber ? downPosition : upperPosition],
                mapType: i <= splitNumber ? "down" : "up"
            }
            let childrenBuckets = buckets[i].children;
            let childPosition = (i <= splitNumber ? initialDownPosition + 4 : initialUpperPosition - 4);
            //to bring parent context at top
            childrenBuckets.sort((a, b) => { if (a.ParentContextid < b.ParentContextid) { return -1; } else return 1; });
            //dedeplicate same children nodes by Contextid
            childrenBuckets = [...new Map(childrenBuckets.map((m) => [m["Contextid"], m])).values()];

            for (let j = 0; j < childrenBuckets.length; j++) {
                propertyArray = [];
                //to create distance between parent and first child
                if (j === 1) {
                    childPosition = i <= splitNumber ? childPosition + 5 : childPosition - 5;
                }
                else childPosition = i <= splitNumber ? childPosition + 3 : childPosition - 3;
                visible = false;

                childrenObj = {
                    id: ((j + 1).toString()) + Math.random(1),
                    Name: childrenBuckets[j].Name ? childrenBuckets[j].Name : "",
                    Contextid: childrenBuckets[j].Contextid ? childrenBuckets[j].Contextid : "",
                    ParentContextid: childrenBuckets[j].ParentContextid,
                    ObjectType: childrenBuckets[j].ObjectType ? childrenBuckets[j].ObjectType : "",
                    parentPosition: i <= splitNumber ? downPosition : upperPosition,
                    position: [childPosition, j === 0 ? 1.5 : 1, i <= splitNumber ? downPosition : upperPosition],
                    mapType: i <= splitNumber ? "down" : "up",
                    isParent: j === 0 ? true : false,
                    visible: visible
                }
                let childrenBucketsLevel2 = childrenBuckets[j].property;
                for (let k = 0; k < childrenBucketsLevel2.length; k++) {
                    let Status = childrenBucketsLevel2[k].Status ? parseInt(childrenBucketsLevel2[k].Status) : "";
                    propertyObj = {
                        //id: ((k + 1).toString()) + Math.random(1),
                        Name: childrenBucketsLevel2[k].Name ? childrenBucketsLevel2[k].Name : "",
                        //Contextid: childrenBucketsLevel2[k].Contextid ? childrenBucketsLevel2[k].Contextid : "",
                        //ParentContextid: childrenBucketsLevel2[k].ParentContextid,
                        //ObjectType: childrenBucketsLevel2[k].ObjectType ? childrenBucketsLevel2[k].ObjectType : "",
                        Category: childrenBucketsLevel2[k].Category ? childrenBucketsLevel2[k].Category : "",
                        Status: Status,
                        Color: determineStatusColor(Status),
                        propertyElements: childrenBucketsLevel2[k].propertyElements.map(val => { return { ...val, isParent: j === 0 ? true : false } })
                    }
                    propertyArray.push(propertyObj);
                    childrenObj.property = propertyArray;
                }
                childrenArray.push(childrenObj);
                boxObj.property = childrenArray[0].property;
                boxObj.children = childrenArray;
            }
            boxArray.push(boxObj);
        }
        console.log(boxArray, "boxArray");
        return boxArray;
    }

    function Box(props) {
        return (
            <mesh {...props}>
                <boxBufferGeometry args={[1, 2, 1]} attach="geometry" />
                <meshBasicMaterial attach="material-0" map={props.rightMap} />{/*front */}
                <meshBasicMaterial attach="material-1" map={props.rightMap} />{/*back */}
                <meshBasicMaterial attach="material-2" map={props.topMap} />{/*top */}
                <meshBasicMaterial attach="material-3" map={props.topMap} />{/* down*/}
                <meshBasicMaterial attach="material-4" map={props.frontMap} />{/*left */}
                <meshBasicMaterial attach="material-5" map={props.frontMap} />{/*right */}
                {props.htmlHoverContent && props.htmlHoverContent}
            </mesh>
        );
    }

    function BorderShadow({ array, ParentCollapseNumber, borderColor, type }) {
        let args; //to determine if the square should be bigger(parent) or smaller(child)
        if ((array.isParent && array.isParent === true) || type === "parent") {
            args = 3;
        } else args = 2;

        return (
            <>
                <mesh position={[array.position[0] + ParentCollapseNumber, 0.1, array.position[2]]} scale={1} visible={true} >
                    <points >
                        <boxBufferGeometry args={[args, 0.2, args, 20, 10, 20]} />
                        <pointsMaterial size={0.01} color={borderColor} attach="material-0" />
                        <pointsMaterial size={0.01} color={borderColor} attach="material-1" />
                        {/* <pointsMaterial size={0} color={"white"} attach="material-2" opacity={1} />*/}
                        <pointsMaterial size={0} color={borderColor} attach="material-3" opacity={0} />
                        <pointsMaterial size={0.01} color={borderColor} attach="material-4" />
                        <pointsMaterial size={0.01} color={borderColor} attach="material-5" />
                    </points>
                </mesh>
                <mesh position={[array.position[0] + ParentCollapseNumber, 0.3, array.position[2]]} scale={1} visible={true} >
                    <points >
                        <boxBufferGeometry args={[args, 0.2, args, 20, 10, 20]} />
                        <pointsMaterial size={0.008} color={borderColor} attach="material-0" />
                        <pointsMaterial size={0.008} color={borderColor} attach="material-1" />
                        <pointsMaterial size={0.008} color={borderColor} attach="material-4" />
                        <pointsMaterial size={0.008} color={borderColor} attach="material-5" />
                    </points>
                </mesh>
                <mesh position={[array.position[0] + ParentCollapseNumber, 0.5, array.position[2]]} scale={1} visible={true} >
                    <points >
                        <boxBufferGeometry args={[args, 0.2, args, 10, 10, 10]} />
                        <pointsMaterial size={0.006} color={borderColor} attach="material-0" />
                        <pointsMaterial size={0.006} color={borderColor} attach="material-1" />
                        <pointsMaterial size={0.006} color={borderColor} attach="material-4" />
                        <pointsMaterial size={0.006} color={borderColor} attach="material-5" />
                    </points>
                </mesh>
            </>
        );
    }


    let centerParent = true;
    for (let i = 0; i < SAPMonitoringData.length; i++) {
        if (SAPMonitoringData[i] && SAPMonitoringData[i].children) {

            for (let j = 0; j < SAPMonitoringData[i].children.length; j++) {
                if (SAPMonitoringData[i].children[j].visible === true) {
                    centerParent = false;
                }
            }
        }
    }
    return (
        SAPMonitoringLoading ?
            <Html scaleFactor={0.3} visible={true}>
                <div className='loader'>
                    <InlineLoading /> {loadingLabel}
                </div>
            </Html> :
            SAPMonitoringData.length > 0 ?
                <>
                    {/* <ambientLight /> */}
                    {SAPMonitoringData.map((node, index) => {
                        let borderColor = "#36b6b4";
                        let showBorder = false;
                        let parentProperty = [];
                        if (node && node.property && node.property.length > 0) {
                            node.property.filter(item => {
                                if (item.Category === selectedLens) {
                                    if (item.Status === 3) {
                                        borderColor = item.Color;
                                        showBorder = true;
                                    }
                                    parentProperty = item.propertyElements;
                                }
                            });
                        }
                        let ParentCollapseNumber = (props.IsExpandCollapse === "collapse" || centerParent === true) ? 10 : 0; // used for showing collapsed boxes in front
                        return <group key={node.id}>
                            {/* parent names*/}
                            <Billboard position={[node.position[0] + ParentCollapseNumber, node.position[1] + 2.5, node.position[2]]}>
                                <Text
                                    color="white"
                                    anchorX="center"
                                    anchorY="center"
                                    fontSize={0.7}
                                    text={node.Name}
                                    z={100}
                                    outlineColor="black"
                                    outlineWidth={0.08}
                                    overflowWrap="break-word"
                                />
                            </Billboard>

                            {/* parent boxes */}
                            <Box position={[node.position[0] + ParentCollapseNumber, node.position[1], node.position[2]]} scale={1.5} visible={true}
                                rightMap={server1Right} frontMap={server1Front} topMap={server1Top}
                                onClick={(e) => {
                                    e.stopPropagation(); handleParentClick(node.id, parentProperty);
                                    setChildrenClickID(node.children && node.children[0] && node.children[0].id ? node.children[0].id : "");
                                    setSelectedName(node.Name);
                                }}
                                onPointerOver={(e) => { setChildHoverID("") }}
                                onPointerOut={(e) => { setChildHoverID("") }} />

                            {showBorder && <BorderShadow array={node} ParentCollapseNumber={ParentCollapseNumber} borderColor={borderColor} type="parent" />}

                            <gridHelper args={[3, 1, borderColor, borderColor]} position={[node.position[0] + ParentCollapseNumber, 0, node.position[2]]} />

                            {/* condition for child box highlight color as per selected lens */}
                            {node && node.children && node.children.length > 0 && node.children.map((child, index) => {
                                let borderColor = "grey"; let propertyMapping = []; let showBorder = false;
                                if (child.property && child.property.length > 0) {
                                    child.property.filter(item => {
                                        if (item.Category === selectedLens) {
                                            borderColor = item.Color;
                                            propertyMapping = item.propertyElements;
                                            showBorder = true;
                                        }
                                    });
                                }
                                return <group key={child.id}>
                                    {child.mapType === "up" ?
                                        <Line visible={child.visible}
                                            points={[[node.position[0] - 1.5, 0, node.position[2]],
                                            [node.children[0].position[0] + 1.5, 0, child.position[2]]]}
                                            color={"#8D8D8D"} dashed dashSize={0.3} gapSize={0.4} />
                                        :
                                        <Line visible={child.visible}
                                            points={[[node.position[0] + 1.5, 0, node.position[2]],
                                            [node.children[0].position[0] - 1.5, 0, child.position[2]]]}
                                            color={"#8D8D8D"} dashed dashSize={0.3} gapSize={0.4} />}

                                    {child.mapType === "up" ?
                                        <Line visible={child.visible}
                                            points={[[node.children[0].position[0] - 1.5, 0, node.children[0].position[2]],
                                            [node.children[1].position[0] + 1.5, 0, node.children[1].position[2]]]}
                                            color={"#8D8D8D"} dashed dashSize={0.3} gapSize={0.4} />
                                        :
                                        <Line visible={child.visible}
                                            points={[[node.children[0].position[0] + 1.5, 0, node.children[0].position[2]],
                                            [node.children[1].position[0] - 1.5, 0, node.children[1].position[2]]]}
                                            color={"#8D8D8D"} dashed dashSize={0.3} gapSize={0.4} />}
                                    <group>
                                        {child.visible && <Box position={child.position} visible={child.visible}
                                            onPointerOver={(e) => { e.stopPropagation(); childHoverID !== child.id && setChildHoverID(child.id); }}
                                            onPointerOut={(e) => { e.stopPropagation(); setChildHoverID("") }}
                                            onClick={(e) => {
                                                // childHoverID !== child.id && setChildHoverID(child.id);
                                                e.stopPropagation(); setChildrenClickID(child.id); props.getSelectedNodeDetails(propertyMapping, child.Name); setSelectedName(child.Name) //props.getSelectedNodeDetails(propertyMapping)
                                            }}
                                            scale={child.isParent === true ? 1.5 : 1} borderColor={borderColor}
                                            rightMap={child.isParent === true ? server2Right : server3Right}
                                            frontMap={child.isParent === true ? server2Front : server3Front}
                                            topMap={child.isParent === true ? server2Top : server3Top}
                                            htmlHoverContent={
                                                child.id === childHoverID &&
                                                <Html scaleFactor={0.3} visible={child.visible && child.id === childHoverID} style={{ pointerEvents: "none", display: child.id === childHoverID ? "block" : "none" }}>
                                                    <div className='tooltip-content'>
                                                        {child.Name}
                                                    </div>
                                                </Html>
                                            }
                                        />
                                        }
                                        <gridHelper visible={child.visible} args={[3, 1, child.isParent === true ? "white" : "grey", child.isParent === true ? "white" : "grey"]} position={[child.position[0], 0, child.position[2]]} />
                                    </group>
                                    {
                                        child.visible && child.property && child.property.length > 0 && showBorder &&
                                        //  <Selection>
                                        //      <EffectComposer multisampling={0}>
                                        //      <SelectiveBloom mipmapBlur radius={0.6} luminanceThreshold={0.1} intensity={1} />
                                        //  </EffectComposer>
                                        //     <Select enabled={true}>
                                        <>
                                            {/* <mesh position={[child.position[0], 0.05, child.position[2]]} key={index} scale={child.isParent ? 1.5 : 1}>
                                            <boxBufferGeometry args={[2, 0.08, 2]} />
                                            <meshBasicMaterial attach="material-0" color={borderColor} transparent opacity={0.8} />
                                            <meshBasicMaterial attach="material-1" color={borderColor}  transparent opacity={0.8}/>
                                            <meshBasicMaterial attach="material-4" color={borderColor}  transparent opacity={0.8}/>
                                            <meshBasicMaterial attach="material-5" color={borderColor}  transparent opacity={0.8}/>
                                        </mesh> */}
                                            <BorderShadow array={child} ParentCollapseNumber={0} borderColor={borderColor} type="child" />
                                        </>
                                        //</Select>
                                        //</Selection>
                                    }
                                </group>
                            })}
                        </group>
                    })}
                    <OrbitControls enablePan={false} enableZoom={true} enableRotate={true} maxDistance={150} minDistance={2} />
                    {/* <gridHelper args={[60, 50, "red", "grey"]} /> */}
                </> : <Html scaleFactor={0.3} visible={true}>
                    <div className='loader'>
                        {NoDataAvailable}
                    </div>
                </Html>
    );
}

export default Scene3D;
